import useFetch from "../../hooks/useFetch"
import { defaultBool } from "../../utils"

export default () => {
  const fetch = useFetch()

  const fetchOpportunities = async (options = {}) => {
    options.isPhysicalOnly = defaultBool(options.isPhysicalOnly, true)
    options.isPhysicalLineItemsOnly = defaultBool(options.isPhysicalLineItemsOnly, true)
    
    const params = new URLSearchParams(Object.entries(options).filter(e => e[1] !== undefined))
  
    const result = await fetch(`accounts/opportunitiesSummary${params.size > 0 ? `?${params.toString()}` : ''}`)
    const resultJson = await result.json()
    return resultJson
  }
  
  const fetchOpportunityRefreshCache = async (options) => {
    const params = new URLSearchParams(Object.entries(options).filter(e => e[1] !== undefined))
  
    const result = await fetch(`accounts/opportunity/updateCache${params.size > 0 ? `?${params.toString()}` : ''}`)
    const resultJson = await result.json()
    return resultJson
  }

  return {
    fetchOpportunities,
    fetchOpportunityRefreshCache
  }
}